module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-US":{"placeholder":"Enter your question or problem","button":"Search"},"pt-BR":{"placeholder":"Digite qual sua dúvida ou problema","button":"Buscar"}}')
  delete Component.options._Ctor
}
